import firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBMt0aQiYzMWBSV77BVcXEvqK0K3Fwx2M4",
  authDomain: "icami-map.firebaseapp.com",
  projectId: "icami-map",
  storageBucket: "icami-map.appspot.com",
  messagingSenderId: "218549137259",
  appId: "1:218549137259:web:2dbfbae09e7bdbb134262e",
  measurementId: "G-246VWMC0EB"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
